<template>
  <div>
  <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <!-- <div class="container-fluid pb-3">
          <div class="row">
            <div class="col-sm-12">
              <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
                 <div class="col-md-6 pt-4">
                  <h2 class="naranja">¡Hola Juan!</h2>
                  <h2>¿Qué necesitas hacer?</h2>
                </div>

                <div class="col-md-6 pt-4">
                  <div class="float-md-right">
                    <div class="status">
                      <div>
                        <i class="far fa-check-circle fa-2x"></i>
                      </div>
                      <div>
                        <div>Contrato activo</div>
                        <div>Vigencia: 20 de marzo de 2020</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="pt-3">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10">
              <div class="row headercontenido">
                <div class="col-6 col-md-6">
                  <span class="titulo sub">
                    <router-link to="/dashboard/alumnos">Alumnos</router-link>
                    <i class="fa fa-chevron-right"></i> Grupo
                  </span>
                </div>
                <!-- <div class="col-6 col-md-6">
                  <button class="btnblanco float-right">
                    Nuevo alumno
                    <i class="fa fa-plus-circle"></i>
                  </button>
                </div>-->
              </div>

              <div class="contenido" v-if="this.data != null">
                <div>
                  <div class="row pt-3">
                    <div class="col-sm-6 text-center mb-3">
                      <div class="card">
                        <div class="col-12 datos text-left">
                          <p class="titulo">
                            <i class="fa fa-users"></i> Grupo
                          </p>
                          <div class="row py-3">
                            <div class="col-4 bold">Programa Académico:</div>
                            <div class="col-8">
                              {{this.data.programa}} - {{this.data.codigo}}
                              <br />
                              ({{this.data.tipo_ciclo_escolar}})
                            </div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">No. acuerdo:</div>
                            <div class="col-8">{{this.data.no_acuerdo}}</div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">Grupo:</div>
                            <div class="col-8">{{this.data.grupo}}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6 text-center mb-3">
                      <div class="card">
                        <div class="col-12 datos text-left">
                          <p class="titulo">
                            <i class="fa fa-user"></i> Alumno
                          </p>
                          <div class="row py-3">
                            <div class="col-4 bold">Matrícula:</div>
                            <div class="col-8">{{this.matricula}}</div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">Nombre:</div>
                            <div
                              class="col-8"
                            >{{this.data.nombre}} {{this.data.apellido_paterno}} {{this.data.apellido_materno}}</div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">Email:</div>
                            <div
                              class="col-8"
                            ><a :href="'mailto:'+this.data.user_email">{{this.data.user_email}}</a></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pb-2 pt-2">
                  <div class="col-6 col-md-6">
                    <span class="titulo sub">Edición de Calificaciones</span>
                  </div>
                  <!-- <div class="col-6 col-md-6">
                    <button class="btnblanco float-right">
                      Guardar ajustes
                      <i class="fa fa-save"></i>
                    </button>
                  </div> -->
                </div>

                <div class="pb-5">
                  <table
                    class="VueTables__table table table-striped table-bordered table-hover edicioncalificaciones"
                    style="overflow: hidden;"
                  >
                    <thead>
                      <tr>
                        <th>
                          <span class="VueTables__heading">Clave</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Asignatura</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Seriación</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Calificación</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in asignaturas" v-bind:key="item.clave">
                        <td>{{item.clave}}</td>
                        <td>{{item.asignatura}}</td>
                        <td>{{item.seriacion}}</td>
                        <td class="calificacion">
                          <div class="row no-gutters botonera" v-bind:class="{editando: item.edicion}">
                            <div class="col-6">
                              <span class="non">{{item.calificacion}}</span>
                              <input type="text" class="form-control-sm edit" v-model="item.calificacion" />
                            </div>
                            <div class="col-6">
                              <div class="float-right editar btn-sm" @click="toggleCalificacion(item.clave)"><i class="fa fa-edit"></i></div>

                              <div class="float-right cerrar edit btn-sm" @click="toggleCalificacion(item.clave)" title="Cancelar"><i class="fa fa-times"></i></div>
                              <div class="float-right guardar edit btn-sm" @click="guardarCalificacion(item.clave, item.codigo, item.calificacion)" title="Guardar"><i class="fa fa-save"></i></div>
                              
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <span class="loading" v-bind:class="{active: this.$store.state.loading}">
                <img src="../../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../../Components/Header.vue";
import Menu from "../../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "IEEServiciosAcademicos",
  props: {
    msg: String
  },
  data() {
    return {
      matricula: "",
      id_grupo: "",
      columns: ["matricula", "nombre", "user_email"],
      datos: null,
      data: null,
      asignaturas: null,

      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          matricula: "Clave",
          nombre: "Trimestre",
          user_email: "Calificación"
        },
        editableColumns: ["name"],
        sortable: ["nombre"],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed"
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Búsqueda",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas"
        }
      }
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu
  },
  mounted: function() {
  this.$store.state.user = JSON.parse(this.$cookie.get('useriee'));
    AOS.init();

    this.matricula = this.$route.params.matricula;
    this.id_grupo = this.$route.params.id_grupo;

    this.consulta();
  },
  methods: {
    toggleCalificacion(clave){
      this.asignaturas.forEach(element =>{
        if(element.clave == clave){
          element.edicion = !element.edicion;
        }
      });
    },
    guardarCalificacion(clave, codigo, calificacion){

      swal
        .fire({
          title: "Calificacion",
          text: "Se modificará la calificación para el alumno...",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar modificación",
          cancelButtonText: "Cancelar"
        })
        .then(result => {
          if (result.value) {
            console.log("bloqueando");
            var vm = this;
            const https = require("https");
            vm.$store.state.loading = true;

            var qData = {
              matricula: this.matricula,
              id_grupos: this.id_grupo,
              clave: clave,
              codigo: codigo,
              calificacion: calificacion
            };

            let formData = new FormData();

            formData.append("form_data", JSON.stringify(qData));
            //formData.append("cv", this.file);

            console.log("enviando");
            //console.log(this.file);
            console.log(JSON.stringify(qData));

            this.$http
              .post(vm.$store.state.baseurl + 'alumnos/actualizacion-calificacion.php', formData, {
                emulateJSON: true,
                httpsAgent: new https.Agent({ rejectUnauthorized: false }),
                headers: {
                  "Content-Type": "multipart/form-data"
                  //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
                }
              })
              .then(
                response => {
                  // get body data
                  console.log("envio");
                  console.log(response);
                  vm.$store.state.loading = false;

                  vm.toggleCalificacion(clave);
                  
                },
                error => {
                  // error callback
                  console.log("error callback");
                  console.log(error);
                  vm.$store.state.loading = false;
                  //console.log(userData);
                  swal.fire(
                    "Oops",
                    "Ha ocurrido un error, por favor intenta de nuevo.",
                    "warning"
                  );
                }
              );
          }
        });

      
    },
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_plantel: this.$store.state.user.id_plantel,
        matricula: this.matricula,
        id_grupo: this.id_grupo
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "alumnos/consulta-grupo-alumno.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.data = res.datos[0];
              this.asignaturas = res.asignaturas;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var userData = {
        /*nombre: this.nombre,
        apellido: this.apellido,
        email: this.email,
        tel: this.tel,
        no_ticket: this.no_ticket,
        sede: this.sede*/
      };

      let formData = new FormData();

      formData.append("form_data", JSON.stringify(userData));
      //formData.append("cv", this.file);

      console.log("enviando");
      //console.log(this.file);
      console.log(JSON.stringify(userData));

      this.$http
        .post(
          vm.$store.state.baseurl + "alumnos/consulta-alumno.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              this.registro = 1;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );

      this.$router.push("dashboard");
    }
  }
};
</script>

